"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIncrementor = void 0;
var _react = require("react");
/**
 * Returns a counter, particularly useful for incrementing keys
 * to force component reinstantiation.
 *
 * @returns [count, incrementCount]
 */
const useIncrementor = function () {
  let initialCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  const [count, setCount] = (0, _react.useState)(initialCount);
  const incrementCount = (0, _react.useCallback)(() => {
    setCount(count + 1);
  }, [count, setCount]);
  return [count, incrementCount];
};
exports.useIncrementor = useIncrementor;
//# sourceMappingURL=useIncrementor.js.map